module.exports = [{
      plugin: require('/tmp/54de96da/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
